import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Menu } from './shared/interfaces/menu.interface';
import { MENU } from './shared/utils/menu';

@Component({
  selector: 'app-designguide',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  menu: Menu[] = MENU;

  constructor(private readonly route: ActivatedRoute, private readonly router: Router) {
    router.initialNavigation();
  }
}
